/**
 * Green Flag — Tabs recipe (pill tabs)
 *
 * The Dating / Friends / Likes Me segmented tab row. This isn't a wrapper
 * on Chakra's Tabs primitive — it's a dedicated PillTabs component (see
 * `components/PillTabs.tsx`) that consumes this recipe via `useRecipe`.
 *
 * States:
 *   - active   → mint bg (`bg.brandSoft`), forest-ink text, bold
 *   - inactive → subtle gray bg, default ink text, normal weight
 */

import { defineSlotRecipe } from "@chakra-ui/react";

export const pillTabsRecipe = defineSlotRecipe({
  className: "gf-pill-tabs",
  slots: ["root", "tab", "tabIcon", "tabLabel"],

  base: {
    root: {
      display: "flex",
      gap: "2",
      w: "full",
    },
    tab: {
      flex: 1,
      h: "33px",
      borderRadius: "pill",
      border: 0,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "2",
      cursor: "pointer",
      fontFamily: "body",
      fontSize: "md",
      transitionProperty: "background-color, color",
      transitionDuration: "normal",
      bg: "bg.subtle",
      color: "fg.default",
      fontWeight: "normal",
      _focusVisible: { outline: "none", boxShadow: "focusRing" },
    },
    tabIcon: {
      w: "14px",
      h: "14px",
    },
    tabLabel: {
      lineHeight: "tight",
    },
  },

  variants: {
    state: {
      active: {
        tab: {
          bg: "bg.brandSoft",
          color: "fg.onTint",
          fontWeight: "bold",
        },
      },
      inactive: {},
    },
  },

  defaultVariants: {
    state: "inactive",
  },
});
